import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import Section from '../../../components/ui/Section';
import SectionTitle from '../../../components/ui/SectionTitle';
import SkillsList from './SkillsList';

function Skills() {
  const tilteInfo = {
    subTitle: 'MY SKILLS',
    title: 'Languages, Technologies & Tools',
    description: '',
  };

  return (
    <Section className="">
      <SectionTitle className="text-center" tilteInfo={tilteInfo} />
      <SkillsList className="mt-10" />
      <Button
        className="mt-12 block w-fit mx-auto"
        variant="contained"
        component={Link}
        to="/portfolio"
      >
        preview My portfolio
      </Button>
    </Section>
  );
}

export default Skills;
